import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import HubspotForm from 'react-hubspot-form'

const HubspotContainer = styled.div`
  .field {
    margin: 2em 0;
  }

  label {
    display: block;
    margin-bottom: 0.6rem;
    cursor: pointer;
  }

  input {
    padding: 0.4rem 0.6rem;
    width: 100%;
    max-width: ${({ limitWidth }) => (limitWidth ? '35rem' : '100%')};
    border: 0.1rem solid
      ${({ error, theme }) =>
        error ? theme.colors.fail : theme.colors.pageRule};
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.pageRule : 'transparent'};
    color: ${({ theme }) => theme.colors.text};

    &[type='number'] {
      max-width: 12rem;
    }
  }

  textarea {
    padding: 0.4rem 0.6rem;
    width: 100%;
    max-width: 100%;
    border: 0.1rem solid
      ${({ theme }) => theme.alternative.colors.secondaryText};
    background-color: transparent;
    resize: vertical;
    color: #ffffff;
  }

  ul {
    list-style: none;
    font-size: 1.3rem;
    padding-top: 20px;
    color: ${({ theme }) => theme.colors.fail};
  }

  input[type='submit'] {
    background-color: ${({ theme }) => theme.colors.interactive};
    border: none;
    border-radius: 0.2rem;
    letter-spacing: 0.1em;
    padding: 0.6rem 1.8rem;
    font-weight: 600;
    transition: background-color 0.2s ease-in-out;
    cursor: pointer;
    display: inline-block;
    max-width: 11rem;
    text-align: center;
  }

  input[type='file'] {
    position: relative;
    visibility: hidden;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      content: '${({ lang }) =>
        lang === 'jp' ? 'ファイルをアップロード' : 'Upload File'}';
      display: block;
      visibility: visible;
      background-color: ${({ theme }) => theme.colors.interactive};
      border: none;
      padding: 0.6rem 1.8rem;
      transition: background-color 0.2s ease-in-out;
      cursor: pointer;
      display: inline-block;
      text-align: left;
    }
  }

  #fileupload {
    position: relative;
    border: 0.1rem solid
      ${({ error, theme }) =>
        error ? theme.colors.fail : theme.colors.pageRule};
    padding: 10px;
  }

  #filename {
    display: block;
  }

  select {
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 100%;
    display: block;
    color: #ffffff;
    padding: 0.6rem 0.6rem;

    option {
      color: ${({ theme }) => theme.alternative.colors.secondaryText};
    }
  }

  .actions {
    text-align: right;
  }
`

export const CommercialContactForm = ({ content, lang }) => {
  const [formReady, setFormReady] = useState(false)
  const [formSubmitted, setFormSubmitted] = useState(false)

  useEffect(() => {
    const addListener = () => {
      // Select the file upload input
      const fileUpload = document.querySelector('input[type="file"]')

      // Add an id on to the parent so we can style it later
      fileUpload.parentElement.setAttribute('id', 'fileupload')

      // Add an element after the upload button which will contain any textarea
      const span = document.createElement('span')
      span.setAttribute('id', 'filename')
      fileUpload.insertAdjacentElement('afterend', span)

      // Listener for when the value of the input changes
      fileUpload.addEventListener('change', (e) => {
        // set the text of our new span to the filename - the fakepath that gets prepended on windows
        span.innerHTML = e.target.value.replace('C:\\fakepath\\', '')
      })
    }

    // Runs when the form is ready and has rendered
    if (formReady) addListener()
  }, [formReady])

  // Hubspot does not play nicely with react out of the box... We have to trick it in to thinking jquery is
  // available... This is horrible but it works :(
  useEffect(() => {
    window.jQuery = (nodeOrSelector) => {
      if (typeof nodeOrSelector === 'string') {
        return document.querySelector(nodeOrSelector)
      }
      nodeOrSelector.serializeArray = () => []
      return nodeOrSelector
    }
  }, [])

  return (
    <HubspotContainer lang={lang}>
      <h2>{content.form_title}</h2>
      <hr />
      {!formSubmitted && <p>{content.message}</p>}
      <HubspotForm
        portalId="8848114"
        formId={
          lang === 'jp'
            ? '13261de9-8fcc-4115-b231-15a62d60d383'
            : '46d992bd-d89d-498d-81ac-42c0596c80fb'
        }
        onSubmit={(e) => setFormSubmitted(true)}
        onReady={() => setFormReady(true)}
        loading={<div>Loading...</div>}
        inlineMessage={content.thank_you_response}
      />
    </HubspotContainer>
  )
}
